import styled from "styled-components";
import {
  mediaMinWidth,
  mediaMaxWidth,
} from "../../../theme/mediaQueriesTemplates";

export const TabsWrapper = styled.div`
  margin: 55px 0 0 60px;
  display: flex;
  flex-direction: column;
  ${mediaMaxWidth.tablet} {
    margin: 55px 0 0 0;
  }
`;

export const RouterNav = styled.nav`
  z-index: 2;

  background-color: #e4e5e7;
  height: 100px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  width: 100%;
  transition: 0.2s ease-in-out;

  ${mediaMaxWidth.tablet} {
    // flex-direction: column-reverse;

    &.downScroll {
      top: 55px;
      position: fixed;
      background: white;
    }
  }
`;

export const RouterList = styled.ul`
  list-style: none;
  margin: 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 100%;
  gap: 10px;
  margin-right: 20px;

  ${mediaMaxWidth.tablet} {
    width: 100%;
    padding: 0;
  }
`;

export const RouterItem = styled.li`
  display: flex;
  justify-content: center;
  font-weight: 700;
  margin: 0 0px;
  flex-direction: column;
  position: relative;

  a {
    color: #333;
    text-align: center;
    border: 1px solid #673490;
    border-radius: 25px;
    display: flex;
    gap: 10px;
    justify-content: center;
    align-items: center;

    padding: 10px 20px;

      ${mediaMaxWidth.tablet} {
        height: 40px;
        
        padding: 10px 15px;
      }
    }
    &:hover {
      background-color: #673490;
      border-radius: 25px;
      transition: background-color 1s ease;
      & div{
        color: white;
      }
    }
  }

  a.active {
    background-color: #673490;
      border-radius: 25px;
      transition: background-color 1s ease;
      & div{
        color: white;
      }
    }
  }

  ${mediaMaxWidth.tablet} {
    flex: 1;
    margin: 0;
    padding: 5px 5px;
    text-align: center;
  }
`;

export const FilterItem = styled.div`
  display: flex;
  justify-content: center;
  font-weight: 700;
  margin: 0 20px;
  flex-direction: column;
  position: relative;


  div {
    color: #333;
    text-align: center;
    border: 1px solid #673490;
    border-radius: 25px;
    padding: 10px 20px;
    cursor: pointer;

      ${mediaMaxWidth.tablet} {

        top: 7px;
        left: -5px;
      }
    }
    &:hover {
      background-color: #673490;
      border-radius: 25px;
      transition: background-color 1s ease;
      & div{
        color: white;
      }
    }
  }

  div.active {
    background-color: #673490;
      border-radius: 25px;
      transition: background-color 1s ease;
      & div{
        color: white;
      }
    }
  }

  ${mediaMaxWidth.tablet} {
    flex: 1;
    margin: 0;
    text-align: center;
  }
`;

export const TabIcon = styled.div`
  color: #4a4a4a;

  ${mediaMinWidth.tablet} {
    display: none;
  }
`;

export const TabText = styled.div`
  ${mediaMaxWidth.tablet} {
    text-transform: uppercase;
    font-size: 0.65em;
    font-weight: 600;
    position: relative;
  }
`;
